import Vuex from 'vuex'
import Vue from 'vue'
import storage from '../utils/storage'
import { getUserInfo } from '../api/api'

// 安装插件
Vue.use(Vuex)

// 创建store对象
const store = new Vuex.Store({
    namespaced: true,
    // 存放数据
    state: {

        // 获取开放id
        OPENID: storage.get('OPENID') ? storage.get('OPENID') : '',

        // 获取token
        TOKEN: storage.get('TOKEN') ? storage.get('TOKEN') : '',

        // 获取登录信息
        USERINFO: storage.get('USERINFO') ? storage.get('USERINFO') : '',

        routerList: storage.get('ROUTERLIST') ? storage.get('ROUTERLIST') : {},

        // 首页数据-当前分页
        dataPage: 1,

        // 当前国家信息
        COUNTRY: storage.get('COUNTRY') ? storage.get('COUNTRY') : {},
        
        // 所有国家列表
        COUNTRYLIST: storage.get('COUNTRYLIST')? storage.get('COUNTRYLIST') : {},

        language: storage.get('LANGUAGE')? storage.get('LANGUAGE') : 'en', // 默认语言
    },

    // 修改state中数据的一些方法
    mutations: {
        SET_LANGUAGE(state, language) {
            storage.set('LANGUAGE', language);
            state.language = language;
        },

        // 修改开放id
        updateOpenid(state, data) {
            storage.set('OPENID', data);
            state.OPENID = data;
        },

        // 修改token
        updateToken(state, data) {
            storage.set('TOKEN', data);
            state.TOKEN = data;
        },

        // 修改登录信息
        updateUserInfo(state, data) {
            storage.set('USERINFO', data);
            state.USERINFO = data;
        },

        cacheRoute(state, { encryptstring, name }) {
            state.routerList[name] = { encryptstring }
            storage.set("ROUTERLIST", state.routerList);
        },

        setDataPage(state, data) {
            // storage.set("MENULIST", data);
            state.dataPage = data
        },

        updateCountry(state, data) {
            storage.set('COUNTRY', data);
            state.COUNTRY = data;
        },

        updateCountryList(state, data) {
            storage.set('COUNTRYLIST', data);
            state.COUNTRYLIST = data;
        },
    },

    // 异步方法
    actions: {
        updateLanguage({ commit }, language) {
            commit('SET_LANGUAGE', language);
        },

        updateCachedRoute({ commit }, { encryptstring, name }) {
            commit('cacheRoute', { encryptstring, name });
        },

        /**
         * 获取用户公共信息
         * @param {Object} context - Vuex 上下文对象
         * @param {number} token - 用户的 token
         * @returns {Promise} - 异步操作的 Promise
        */
        async fetchGetUserInfo({ commit }, { token, router }) {
            // 获取COUNTRY
            const country = storage.get('COUNTRY');
            try {
                // 获取用户信息
                const userInfo = await getUserInfo({ token, countryid: country.countryid });

                if (userInfo.result == 'False') {
                    storage.removeAll();
                    router.push("/login");
                } else {

                    //如果country.countryid跟userInfo.ams_shop_exrate中的countryid值相等
                    let exrateObj =  userInfo.ams_shop_exrate.filter(item => item.countryid == country.countryid);

                    //如果country.countryid跟userInfo.ams_shop_country中的countryid值相等
                    let countryObj = userInfo.ams_shop_country.filter(item => item.countryid == country.countryid);

                    // 合并exrateObj和countryObj为对象赋值给userInfo中新增键
                    userInfo.countryExrateObj = {
                        ...exrateObj[0],
                        ...countryObj[0]
                    };  
                    
                    // 提交 mutation 更新用户信息
                    commit('updateUserInfo', userInfo);
                    // 提交 mutation 更新用户的 openid
                    commit('updateOpenid', userInfo.openid);
                    // 提交 mutation 更新国家信息
                    // commit('updateCountry', filter);
                }
            } catch (error) {
                console.error("获取用户信息失败", error);
            }
        },

        // 可以在此添加更多异步操作
        updateCountry({ commit }, obj) {
            commit('updateCountry', obj);
        },

        updateUserInfo({ commit }, data) {
            commit('updateUserInfo', data);
        },

        updateToken({ commit }, data) {
            commit('updateToken', data);
        },

        updateCountryList({ commit }, data) {
            commit('updateCountryList', data);
        },
    },
})

export default store